import {CREATE_REF_SYMBOL} from '../constants';

export default function isRef(ref) {
	return ref && ref[CREATE_REF_SYMBOL] ? true : false;
}
